import { getCurrentD3Locale } from 'js/helpers/dateTimeAndNumberFormatting';
export function mapCountryMetadataToName(countryMetadata) {
  return countryMetadata.name;
}
export function mapCountryMetadataToPlotsMetadata(countryMetadata) {
  return countryMetadata.plots;
}
export function constructPopulationString(population) {
  return getCurrentD3Locale().numberFormat('.3s')(population);
}